export const environment = {
    production: false,
    host:"https://previnapp-ia-backend-dev.useitia.com",
    //host:"http://localhost:8000"
};
